import React, { useState, useEffect, useContext } from "react";
import { Grid, Box } from "@mui/material";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";
import Loading from "../components/Loading";

const patientDistributionOptions = {
  hoverLayerThreshold: Infinity,
  title: {
    text: "Patient Distribution By State",
    left: "right",
  },
  tooltip: {
    trigger: "item",
    showDelay: 0,
    transitionDuration: 0.2,
  },
  visualMap: {
    left: "right",
    min: 1,
    max: 376,
    inRange: {
      color: [
        "#313695",
        "#4575b4",
        "#74add1",
        "#abd9e9",
        "#e0f3f8",
        "#ffffbf",
        "#fee090",
        "#fdae61",
        "#f46d43",
        "#d73027",
        "#a50026",
      ],
    },
    text: ["High", "Low"],
    calculable: true,
  },
  toolbox: {
    show: true,
    left: "left",
    top: "top",
    feature: {
      dataView: {
        readOnly: false,
      },
      restore: {},
      saveAsImage: {},
    },
  },
  series: [
    {
      name: "Patient Distribution By State",
      type: "map",
      roam: true,
      map: "USA",
      emphasis: {
        label: {
          show: true,
        },
      },
      data: [
        {
          name: "District of Columbia",
          value: 83,
        },
        {
          name: "Mississippi",
          value: 25,
        },
        {
          name: "Washington",
          value: 1,
        },
        {
          name: "Pennsylvania",
          value: 1,
        },
        {
          name: "Virginia",
          value: 1,
        },
        {
          name: "Illinois",
          value: 1,
        },
        {
          name: "Florida",
          value: 1,
        },
        {
          name: "Georgia",
          value: 1,
        },
        {
          name: "Louisiana",
          value: 1,
        },
        {
          name: "California",
          value: 1,
        },
        {
          name: "Oregon",
          value: 376,
        },
        {
          name: "Texas",
          value: 26,
        },
        {
          value: 1,
        },
        {
          name: "New Jersey",
          value: 16,
        },
        {
          name: "Tennessee",
          value: 8,
        },
        {
          name: "Alabama",
          value: 107,
        },
        {
          name: "New Mexico",
          value: 4,
        },
        {
          name: "Michigan",
          value: 2,
        },
        {
          name: "New York",
          value: 1,
        },
        {
          name: "Nebraska",
          value: 1,
        },
        {
          name: "Missouri",
          value: 6,
        },
        {
          name: "Arizona",
          value: 1,
        },
        {
          name: "Kentucky",
          value: 1,
        },
        {
          name: "Ohio",
          value: 1,
        },
        {
          name: "Kansas",
          value: 24,
        },
        {
          name: "Arkansas",
          value: 1,
        },
        {
          name: "Delaware",
          value: 3,
        },
        {
          name: "North Carolina",
          value: 1,
        },
        {
          name: "South Carolina",
          value: 1,
        },
        {
          name: "Connecticut",
          value: 1,
        },
        {
          name: "Indiana",
          value: 71,
        },
        {
          name: "Massachusetts",
          value: 1,
        },
        {
          name: "Colorado",
          value: 1,
        },
        {
          name: "Maryland",
          value: 12,
        },
        {
          name: "Idaho",
          value: 2,
        },
        {
          name: "Minnesota",
          value: 1,
        },
        {
          name: "Wisconsin",
          value: 1,
        },
        {
          name: "West Virginia",
          value: 1,
        },
        {
          name: "Oklahoma",
          value: 2,
        },
        {
          name: "Alaska",
          value: 1,
        },
        {
          name: "South Dakota",
          value: 1,
        },
        {
          name: "Nevada",
          value: 2,
        },
      ],
    },
  ],
};
const Variation2 = () => {
  return (
    <Box
      sx={{
        height: "93vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loading />
    </Box>
  );
};

export default Variation2;
